import { render, staticRenderFns } from "./editDescriptionAndComments.vue?vue&type=template&id=b8285d52&scoped=true&"
import script from "./editDescriptionAndComments.vue?vue&type=script&lang=js&"
export * from "./editDescriptionAndComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8285d52",
  null
  
)

export default component.exports